// Firebase configuration for ClubLink TT
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBLB2qKKd2Tjl1j_xUxf4hSHwZ18V5GjXI",
  authDomain: "pro-series-fc.firebaseapp.com",
  projectId: "pro-series-fc",
  storageBucket: "pro-series-fc.firebasestorage.app",
  messagingSenderId: "56714240014",
  appId: "1:56714240014:web:66914c4eaa902584bf5c5f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
